import { cn } from "@/utils/cn";

type SidebarCardProps = {
  children: React.ReactNode;
  className?: string;
};

export function SidebarCard({ children, className }: SidebarCardProps) {
  return (
    <section
      className={cn(
        "rounded-2xl border border-border-secondary bg-bg-primary p-6 shadow-xs",
        className,
      )}
    >
      {children}
    </section>
  );
}
